module.exports = __webpack_public_path__ + "img/test2.81551ce3.jpg";